import React, { useState } from 'react';
import moment from 'moment';

import { Pagination, Loading, Empty } from '../../../react-common';
import useLockboxAccessLogs from './useLockboxAccessLogs';

type LockboxAccessLogsProps = {
  lockboxType: 'masterlock' | 'sentrilock';
  deviceId: string;
  date?: Date;
};

const LockboxAccessLogs: React.FC<LockboxAccessLogsProps> = ({
  lockboxType,
  deviceId,
  date,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { requestStatus, accessLogs, accessLogsCount } = useLockboxAccessLogs(
    lockboxType,
    deviceId,
    currentPage,
    date,
  );
  if (requestStatus === 'pending') {
    return (
      <div className="row">
        <div className="col-md-12">
          <Loading />
        </div>
      </div>
    );
  }

  if (requestStatus === 'error') {
    return (
      <Empty
        height={'100%'}
        text={'Failed to load access logs. Please try it again'}
      />
    );
  }

  if (accessLogsCount === 0) {
    return <Empty height={'100%'} text={'No Access Log'} />;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <table className="table table-striped table-bordered table-hover">
          {lockboxType === 'masterlock' ? (
            <>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Event</th>
                <th>Agent Name</th>
              </tr>
              {accessLogs.map((log, index) => (
                <tr key={index}>
                  <td>{moment(log.timestamp).format('DD-MMM-YYYY')}</td>
                  <td>{moment(log.timestamp).format('hh:mm:ss A')}</td>
                  <td>{log.event}</td>
                  <td>
                    {log.agentFirstName} {log.agentLastName}
                    <br />
                    {log.agentOfficeName}
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <>
              <tr>
                <th>Access Time</th>
                <th>Access Type</th>
                <th>Access By Name</th>
                <th>MLS Number</th>
              </tr>
              {/* TODO: update type */}
              {accessLogs.map((log: any, index) => (
                <tr key={index}>
                  <td>{log['Accessed By']?.['Access Time']}</td>
                  <td>{log['Access Type']}</td>
                  <td style={{ width: '40%' }}>{log['Accessed By']?.Name}</td>
                  <td>{log['MLS Number']}</td>
                </tr>
              ))}
            </>
          )}
        </table>
      </div>
      {accessLogsCount > 20 && (
        <div className="col-md-12">
          <Pagination
            itemsPerPage={20}
            totalItems={accessLogsCount}
            currentPage={currentPage}
            onChange={page => setCurrentPage(page)}
          />
        </div>
      )}
    </div>
  );
};

export default LockboxAccessLogs;
